import React, { Component } from 'react'
import QrReader from "react-qr-reader";
import Swal from 'sweetalert2';
import './Scanqr.css';
import QRScanner from './QRScanner';
import axios from 'axios';


// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
});

export default class ScanQR extends Component {
    constructor() {
        super();
        this.qrRef = React.createRef(null);
        this.state = {
          scanResultData: "",
          scanResultWebCam: "",
          clickedOnScan: true,
          words: {},
          lang: "",
          Client : "",
        }
        this.handleScanWebCam = this.handleScanWebCam.bind(this);
        // this.handleScanFile = this.handleScanFile.bind(this);
    }
 
  async componentDidMount(){
    await this.getLang();
    if(this.props.legacyMode){
      this.qrRef.current.openImageDialog();
      this.setState({
        scanResultData : ""
      })
    }
  }

  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  handleError = (error) => {
  }

  // onScanFile = () => {
  //   this.qrRef.current.openImageDialog();
  //   this.setState({
  //     scanResultData : ""
  //   })
  // }

  handleScanFile = (result) =>  {
    if (result) {
        this.props.handleScanFile(result.split("\r\n"));
        this.setState({
          scanResultData : result
        })
    }
  }

  handleScanWebCam(result) {
    const { legacyMode } = this.props;
    let Data = result;
    if (result) {
      // result = decodeURIComponent(result);
      let stringCorrect = result.includes('client') || result.includes('claimNumber') || result.includes('Firma') || result.includes('OrderNo') || result.includes('RegNo') || result.includes('Color') || result.includes('PartnerName') || result.includes('Model') || result.includes("ActualVin") || result.includes("Make")

      let stringUSCorrect = result.includes('Auftragsgeber') || result.includes('claimNumber') || result.includes('Firma') || result.includes('OrderNo') || result.includes('KZ') || result.includes('Farbe') || result.includes('Name') || result.includes('Typ') || result.includes("VIN") || result.includes("Marke") || result.includes("Auftragsnummer")

      let stringCorrectForSlovina = result.includes('estimateID') ||  result.includes('vin') || result.includes('regno') || result.includes('make') || result.includes('model') || result.includes('color')
      var setClient = '';
      if(stringCorrect || stringCorrectForSlovina || stringUSCorrect){
        if(localStorage.getItem("client") == "SWISS"){
          if(result.includes("Mobiliar")){
            setClient = "Mobiliar"
            this.setState({
              Client : "Mobiliar"
            })
          }else if(result.includes("client=&")){
            setClient = ""
            this.setState({
              Client : ""
            })
          }else{
            setClient = "amag"
            this.setState({
              Client : "amag"
            })
          }
        }
        result = result.replaceAll('"','');
        result = stringCorrectForSlovina ? result.split(';') : result.split('&')
        result = result.map((r) => r.split('='))
        this.props.handleScanWebCam(result,Data,setClient);
        this.setState({
          scanResultWebCam : Data,
          clickedOnScan : false
        })
      } else {
        Toast.fire({
          type: 'error',
          title: 'Your QR is malformed. Please try again later.'
        }).then(() => {
          this.props.handleScanWebCam();
        })
      }
    } else if(legacyMode && result === null) {
      Toast.fire({
        type: 'warning',
        title: this.lang('Upload/Scan valid QR!')
      }).then(() => {
        this.props.handleScanWebCam();
      })
    }
  }

  startScan = () => {
      this.setState({
          clickedOnScan : true,
          scanResultWebCam : ""
      })
  }
    render() {
        const { legacyMode } = this.props
        const {scanResultWebCam, scanResultData, clickedOnScan} = this.state
        return (
            <div>
                {legacyMode && 
                    <div className='main-div-button'>
                        <QrReader
                            ref={this.qrRef}
                            delay={300}
                            className="qr-section"
                            // style={{width: '60%',margin : "0 auto"}}
                            onError={this.handleError}
                            onScan={this.handleScanWebCam}
                            legacyMode
                        />
                        {/* {scanResultData && <p>Scanned Code : {scanResultData}</p>} */}
                    </div>
                }
                {!legacyMode &&
                    <div>
                        <QRScanner handleScanWebCam={(result) => this.handleScanWebCam(result)}/> 
                        {/* <button 
                            className="dropdown-toggle btn btn-primary mb-3" 
                            type="button"
                            aria-expanded="false"
                            aria-haspopup="true"
                            aria-label="Dropdown toggle"
                            onClick={() => this.startScan()}
                        >
                            Scan QR Code
                        </button> */}
                        {/* {clickedOnScan &&
                        <QrReader
                            delay={300}
                            // style={{width: '60%',margin: "0 auto"}}
                            className="qr-section"
                            onError={this.handleError}
                            onScan={this.handleScanWebCam}
                        /> 
                        }  */}
                        {/* {scanResultWebCam && <p>Scanned Output : {scanResultWebCam}</p>} */}
                    </div>
                }
            </div>
        )
    }
}